<script setup lang="ts">
export interface Props {
  title: string,
  status: string | undefined,
  statusText: string,
}

const props = defineProps<Props>();
</script>

<template>
  <div
    :class="[
      'ui-status-block',
      `ui-status-block_${status}`
    ]"
  >
    {{ props.title }}
    <UiStatusText
      :type="props.status"
      :text="props.statusText"
      bold
    />
  </div>
</template>

<style lang="scss">
.ui-status-block {
  display: flex;
  height: 34px;
  padding: 9px 8px;
  align-items: center;
  gap: 4px;
  border-radius: 5px;
  white-space: nowrap;

  color: var(--text-body-secondary);
  font-size: 12px;
  font-weight: 400;

  &_processing{
    background: var(--background-info-subtle);
  }
  &_on_review,
  &_waiting_approve {
    background: var(--background-warning-subtle);
  }

  &_for_rework,
  &_failed,
  &_rejected,
  &_declined,
  &_cancelled,
  &_not_paid {
    background: var(--background-negative-subtle);
  }

  &_paid,
  &_approved {
    background: var(--background-positive-subtle);
  }

}
</style>
